// instagram

// Extend namespace by creating a new object
pyzel.instagram = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.instagram.init = function( user_id ) {		

	$.ajax({
	    	
	    type: "GET",
	    dataType: "jsonp",
	    cache: false,
	    //this is the token of pictures feed app of user @pedrosilvashaperbuddy
	    //url: "https://api.instagram.com/v1/users/23630467/media/recent/?access_token=3314912590.dd3641f.b0a044bae2bd4e8688db295404f4d42d"
	    //this is the token of Smash Balloon WordPress Plugin App of user @pedrosilvashaperbuddy ( hack mode on! )
	    url: "https://api.instagram.com/v1/users/"+user_id+"/media/recent/?access_token=3314912590.3a81a9f.b1e95453cb22446e836e2949ade741ec"
	    // get user id using this: https://smashballoon.com/instagram-feed/find-instagram-user-id/

	}).done( function( r ){
	    
	    let html = '';
	    let photos = 6;
	    //let loops = 0;
		let xs_class = 'col-xs-6';	    


	    //$.each( r.data, function(){
	    $.each( r.data, (key, value) =>{

	        //loops++;
	        
	        if( key < photos ){

	        	if( key > 3 ) xs_class = 'hidden-xs';
	         
	            html += 
	                
	            `<div class="col-sm-2 ${ xs_class }">

	                <a href="${ value.link }" target="_blank">

	                    <img src="${ value.images.low_resolution.url }" class="img-responsive">

	                </a>

	            </div>`;            
	            
	        }
	        
	        return;        
	           
	    })
	    
	    $('#instagram-feed').html( html );
	    
	});


};

// hackish mode..
// does not work with ajax, must be with PHP..
/*
pyzel.instagram.get_user_id = ( url )=>{

	//console.log( username );
	
	$.ajax({

		url: url+'/?__a=1',		
		//dataType: 'jsonp',
		//jsonp: '',
		crossOrigin: true,

	}).done( (r)=>{

		console.log( r );

	})	

}

pyzel.instagram.get_user_id('https://www.instagram.com/anastasiaashley');
*/